import { computeFilteredSegment } from "helpers/segments"
import { createSelector } from "reselect"
import { getFilter } from "./filters"
import { getNormalization } from "."

export const getSegment = createSelector(
  [getFilter, getNormalization],
  computeFilteredSegment,
)
